<script>
export default {
  name: "breadcrumb-component",
  props: ["breadcrumb"],
  data() {
    return {
      breadcrumbList: [],
    };
  },
  methods: {
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    },
  },
  mounted() {
    // console.log(this.breadcrumb);
    this.updateList();
  },
  watch: {
    $route() {
      this.updateList();
    },
  },
};
</script>

<template src="./Breadcrumb.html"></template>
<style lang="sass" scoped src="./Breadcrumb.sass"></style>
